// The canonical list of departments a topic can be tagged with. Edit this list to change the
// options in the New-topic picker and the dashboard filter. Topics with no department show under
// "Unassigned" in the filter.
export const DEPARTMENTS = [
  "Engineering",
  "Product",
  "Design",
  "Marketing",
  "Sales",
  "Operations",
  "Leadership",
] as const;

export type Department = (typeof DEPARTMENTS)[number];
